import React from "react";
import ServiceDetailComponent from "../components/ServiceDetailComponent";

const ServiceDetail = () => {
  return (
    <div>
      <ServiceDetailComponent />
    </div>
  );
};

export default ServiceDetail;
